import { RouteRecordRaw } from 'vue-router';


export const menuRoutes: RouteRecordRaw[] = [];
const routes: RouteRecordRaw[] = [
	
];
export default routes;
